var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-detail-list"},_vm._l((_vm.dataList),function(item){return _c('div',{key:item.id,staticClass:"detail-item"},[_c('detail-item',{attrs:{"statusMap":_vm.statusMap,"config":_vm.config,"data":item},on:{"dataUpdate":function($event){return _vm.$emit('dataUpdate')}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }